import React from 'react';
import Modal, { ModalType } from 'legacy/common/components/modal/Modal';

export type RecipientOption = {
  id: string | null;
  name: string;
  guestCount: number;
  isBundle?: boolean;
};

type RecipientPickerProps = {
  visible: boolean;
  onClose: () => void;
  options: RecipientOption[];
  selectedId: string | null;
  onSelect: (option: RecipientOption) => void;
};

const RecipientPicker: React.FC<RecipientPickerProps> = ({
  visible,
  onClose,
  options,
  selectedId,
  onSelect
}) => (
    <Modal
      visible={visible}
      type={ModalType.SMALL}
      onClose={onClose}
      title="Select ticket tier"
    >
      <div className="px-4 pt-4 pb-2">
        <p className="text-sm text-gray-500">
          Select the ticket tier you would like to send an SMS to.
        </p>
      </div>
      <div className="px-4 pb-4 overflow-y-auto">
        {options.map((option) => {
          const isSelected = option.id === selectedId;
          return (
            <button
              key={option.id ?? 'all'}
              type="button"
              className="w-full flex items-center justify-between p-3 rounded-xl hover:bg-gray-50 transition-colors"
              onClick={() => {
                onSelect(option);
                onClose();
              }}
            >
              <div className="flex flex-col items-start">
                <div className="flex items-center gap-2">
                  <span className="font-semibold text-sm">{option.name}</span>
                  {option.isBundle && (
                    <span className="text-xs font-medium bg-primary-50 text-primary-500 px-2 py-0.5 rounded-full">
                      Bundle
                    </span>
                  )}
                </div>
                <span className="text-xs text-gray-400 mt-0.5">
                  {option.guestCount}{' '}
                  {option.guestCount === 1 ? 'guest' : 'guests'}
                </span>
              </div>
              <div
                className={`w-5 h-5 rounded-full border-2 flex items-center justify-center shrink-0 ${
                  isSelected
                    ? 'border-primary-500 bg-primary-500'
                    : 'border-gray-300'
                }`}
              >
                {isSelected && (
                  <div className="w-2 h-2 rounded-full bg-white" />
                )}
              </div>
            </button>
          );
        })}
      </div>
    </Modal>
  );

export default RecipientPicker;
